export const sanitizeCurrencyInput = (value: string) => {
    let sanitizedCurrecy = value.split(",")[0];
    sanitizedCurrecy = sanitizedCurrecy
        .replaceAll(".", "")
        .replaceAll("€", "")
        .replaceAll(" ", "");
    return Number(sanitizedCurrecy);
};
